const doc = [({"ko":({"adminConstantBedType":({"bed":"침대", "futon":"이불", "sofaBed":"소파 베드"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;